<template>
  <div
    class="flex-shrink-1 flex-grow-1"
  >
    <input-text
      v-model="getValue"
      :label="label"
      append-icon="mdi-magnify"
      hide-details
      clearable
      @keypress.enter.native="search($event)"
      @blur="search($event)"
    />
  </div>
</template>

<script>

export default {
  name: 'SearchFilter',
  props: {
    label: {
      type: String,
      default: 'Pesquisar',
    },
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        return value;
      },
    },
  },
  methods: {
    search(ev) {
      const { value } = ev.target;
      this.$emit('input', value);
    },
  },
};
</script>
